// Main entry point for ServiceOps Reservations Components package
// This file exports the Rates object that contains all rate-related components

import { RatesComponent } from './Rates/components';
import type { RatesComponentProps } from './Rates/RatesComponent';

// Export the Rates object that matches your existing usage pattern
export const Rates = {
    RatesComponent: RatesComponent
};

// Export types for TypeScript consumers
export type { RatesComponentProps };

// Re-usable price components + dialogs.
// Exposed so price-block UI (rates, snapshots, etc.) renders identically across the app.
export { RoomPriceComponent } from './EditReservation/RoomPriceComponent';
export type { RoomPriceComponentProps } from './EditReservation/RoomPriceComponent';
export { ProgramPriceComponent } from './EditReservation/ProgramPriceComponent';
export type { ProgramPriceComponentProps } from './EditReservation/ProgramPriceComponent';
export { RoomPriceDialogComponent } from './EditReservation/RoomPriceDialogComponent';
export type { RoomPriceDialogComponentProps } from './EditReservation/RoomPriceDialogComponent';
export { ProgramPriceDialogComponent } from './EditReservation/ProgramPriceDialogComponent';
export type { ProgramPriceDialogComponentProps } from './EditReservation/ProgramPriceDialogComponent';
export { RateFinderPriceDialogComponent } from './RateFinder/RateFinderPriceDialogComponent';
export type { RateFinderPriceDialogComponentProps } from './RateFinder/RateFinderPriceDialogComponent';

// Canonical price calculators — keep tenants on the same battle-tested formula.
// Row rollup carries the per-date breakdowns array; per-date carries one breakdown.
// Discount state is derived where needed via totalBaseAmount > totalPayableAmount.
export { calculateRowPrice, calculateDatePrice } from './EditReservation/model.Reservations';

// Types consumers need to fabricate dialog inputs from arbitrary data
// (e.g. rate snapshots that aren't backed by a live RoomBookingState).
export type {
    PriceBreakdownContainer,
    SplitAmountsContainer,
    AmountWithSource,
    MultiplierWithSource,
    CalculatedPrice,
    CalculatedRowPrice,
    RoomBookingDate,
    RoomBookingDateVoucher,
    RoomBookingDateVoucherEffect,
    RoomBookingState,
    ReservationState,
} from './EditReservation/types';
export type { ExternalPostingStatus } from './EditReservation/types';
export { connectorVerdictConfig, getVerdictBadge, verdictHasReason } from './Pipeline/connectorVerdict';
export type { VerdictBadge } from './Pipeline/connectorVerdict';
export { StatusPill } from './StatusPill';
export type { StatusPillProps } from './StatusPill';
export { ExternalLinkIcon } from './ExternalLinkIcon';
export type { ExternalLinkIconProps } from './ExternalLinkIcon';
export type { ProgramBookingState } from './EditReservation/model.Programs';

// Default export for convenience
export default {
    Rates
};